module.exports = __webpack_public_path__ + "static/media/calendar.7bf775d6.svg";